/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { useState, useEffect } from 'react';
import {
    Modal, ModalHeader, ModalBody,
} from 'reactstrap';
import Comment from '../Comment';
import CommentBox from '../CommentBox';
import ApiCaller from "../../../../api/apiCaller";

const PolygonCommentModal = ({ initialIsOpen, planningPolygonToShowComment, onCancelled }) => {

    const [modal, setModal] = useState(initialIsOpen);
    const [comments, setComments] = useState([]);

    const sitePlanningSelectionAreaId = planningPolygonToShowComment.properties.id;

    const toggle = () => {
        setModal(!modal);
        if (onCancelled) {
            onCancelled();
        }
    }

    const getComments = async () => {
        const uri = `site_planning_selection_area_comment/list?site_planning_selection_area_id=${sitePlanningSelectionAreaId}`;
        const res = await ApiCaller.get(uri);
        if (res?.result) {
            setComments(res?.result);
        }
    }

    useEffect(() => {
        getComments();
    }, [])

    return (
        <Modal isOpen={modal} toggle={toggle} size="md">
            <ModalHeader toggle={toggle}>Nhận xét</ModalHeader>
            <ModalBody>
                <div style={styles.commentBoxContainer}>
                    <CommentBox
                        sitePlanningSelectionAreaId={sitePlanningSelectionAreaId}
                        onCommentSaved={getComments}
                    />
                </div>
                <div>
                    {comments.map(comment =>
                        <Comment
                            key={comment.id}
                            comment={comment}
                        />
                    )}
                </div>
            </ModalBody>
        </Modal>
    );
};

const styles = {
    commentBoxContainer: {
        backgroundColor: 'var(--color-line-light)',
        borderRadius: 6,
        padding: 6,
    },
};

export default PolygonCommentModal;